import { useEffect, useState } from "react";
import type { DateRange } from "react-day-picker";

import { Calendar } from "./calendar";

export type RangeCalendarProps = {
  onRangeChange?: (range: DateRange | undefined) => void;
  from?: Date;
  to?: Date;
};

function RangeCalendar({ onRangeChange, from, to }: RangeCalendarProps) {
  const [date, setDate] = useState<DateRange | undefined>({
    from: from,
    to: to,
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies: adding onRangeChange to deps causes infinite loop
  useEffect(() => {
    onRangeChange?.(date);
  }, [date]);

  return (
    <Calendar
      mode="range"
      captionLayout="dropdown"
      selected={date}
      onSelect={setDate}
      className="rounded border p-2 bg-white"
    />
  );
}

export { RangeCalendar };
